import { ActionCreator } from "../types/store-types";
import {
    FormsActionTypes,
    GetFormRequestActionType,
    GetFormSuccessActionType,
    GetFormFailureActionType,
    GetFormsRequestActionType,
    GetFormsSuccessActionType,
    GetFormsFailureActionType,
    CreateFormRequestActionType,
    CreateFormSuccessActionType,
    CreateFormFailureActionType,
    SetCurrentFormActionType,
    UpdateFormNameRequestActionType,
    UpdateFormNameSuccessActionType,
    UpdateFormNameFailureActionType,
    UpdateFormBackgroundRequestActionType,
    UpdateFormBackgroundSuccessActionType,
    UpdateFormBackgroundFailureActionType,
    UpdateFormPageStylesRequestActionType,
    UpdateFormPageStylesSuccessActionType,
    UpdateFormPageStylesFailureActionType,
    SetFormStylesActionType,
    GetUserFontsRequestActionType,
    GetUserFontsSuccessActionType,
    GetUserFontsFailureActionType,
    SaveChangedFontsRequestActionType,
    SaveChangedFontsSuccessActionType,
    SaveChangedFontsFailureActionType,
    SetInitialFontsActionType,
    UpdateFormButtonsDataRequest,
    InitFormButtonsStylesActionType,
    TransferFormActionType,
    SetTransferFormDataActionType,
    TransferFormSubmissionsActionType,
    SetTransferFormLoadingActionType,
} from "./types";

/* -- Get Form Request Actions --  */

export const getFormRequest: ActionCreator<GetFormRequestActionType> = payload => ({
    type: FormsActionTypes.GET_FORM_REQUEST,
    payload,
});

export const getFormSuccess: ActionCreator<GetFormSuccessActionType> = payload => ({
    type: FormsActionTypes.GET_FORM_SUCCESS,
    payload,
});

export const getFormFailure: ActionCreator<GetFormFailureActionType> = payload => ({
    type: FormsActionTypes.GET_FORM_FAILURE,
    payload,
});

/* -- Get Forms Request Actions --  */

export const getFormsRequest: ActionCreator<GetFormsRequestActionType> = payload => ({
    type: FormsActionTypes.GET_FORMS_REQUEST,
    payload,
});

export const getFormsSuccess: ActionCreator<GetFormsSuccessActionType> = payload => ({
    type: FormsActionTypes.GET_FORMS_SUCCESS,
    payload,
});

export const getFormsFailure: ActionCreator<GetFormsFailureActionType> = payload => ({
    type: FormsActionTypes.GET_FORMS_FAILURE,
    payload,
});

/* -- Create Form Request Actions --  */

export const createFormRequest: ActionCreator<CreateFormRequestActionType> = payload => ({
    type: FormsActionTypes.CREATE_FORM_REQUEST,
    payload,
});

export const createFormSuccess: ActionCreator<CreateFormSuccessActionType> = payload => ({
    type: FormsActionTypes.CREATE_FORM_SUCCESS,
    payload,
});

export const createFormFailure: ActionCreator<CreateFormFailureActionType> = payload => ({
    type: FormsActionTypes.CREATE_FORM_FAILURE,
    payload,
});

/* -- Update Form Name Request Actions --  */

export const updateFormNameRequest: ActionCreator<UpdateFormNameRequestActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_NAME_REQUEST,
    payload,
});

export const updateFormNameSuccess: ActionCreator<UpdateFormNameSuccessActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_NAME_SUCCESS,
    payload,
});

export const updateFormNameFailure: ActionCreator<UpdateFormNameFailureActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_NAME_FAILURE,
    payload,
});

/* -- Update Form Background Request Actions --  */

export const updateFormBackgroundRequest: ActionCreator<UpdateFormBackgroundRequestActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_BACKGROUND_REQUEST,
    payload,
});

export const updateFormBackgroundSuccess: ActionCreator<UpdateFormBackgroundSuccessActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_BACKGROUND_SUCCESS,
    payload,
});

export const updateFormBackgroundFailure: ActionCreator<UpdateFormBackgroundFailureActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_BACKGROUND_FAILURE,
    payload,
});

/* -- Update Form Page Styles Request Actions --  */

export const updateFormPageStylesRequest: ActionCreator<UpdateFormPageStylesRequestActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_PAGE_STYLES_REQUEST,
    payload,
});

export const updateFormPageStylesSuccess: ActionCreator<UpdateFormPageStylesSuccessActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_PAGE_STYLES_SUCCESS,
    payload,
});

export const updateFormPageStylesFailure: ActionCreator<UpdateFormPageStylesFailureActionType> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_PAGE_STYLES_FAILURE,
    payload,
});

export const setCurrentForm: ActionCreator<SetCurrentFormActionType> = payload => ({
    type: FormsActionTypes.SET_CURRENT_FORM,
    payload,
});

export const setFormStyles: ActionCreator<SetFormStylesActionType> = payload => ({
    type: FormsActionTypes.SET_FORM_STYLES,
    payload,
});

/* -- Get User Fonts Request Actions --  */

export const getUserFontsRequest: ActionCreator<GetUserFontsRequestActionType> = payload => ({
    type: FormsActionTypes.GET_USER_FONTS_REQUEST,
    payload,
});

export const getUserFontsSuccess: ActionCreator<GetUserFontsSuccessActionType> = payload => ({
    type: FormsActionTypes.GET_USER_FONTS_SUCCESS,
    payload,
});

export const getUserFontsFailure: ActionCreator<GetUserFontsFailureActionType> = payload => ({
    type: FormsActionTypes.GET_USER_FONTS_FAILURE,
    payload,
});

export const setInitialFonts: ActionCreator<SetInitialFontsActionType> = payload => ({
    type: FormsActionTypes.SET_INITIAL_FONTS,
    payload,
});
/* -- Save Changed User Fonts Request Actions --  */

export const saveChangedFontsRequest: ActionCreator<SaveChangedFontsRequestActionType> = payload => ({
    type: FormsActionTypes.SAVE_CHANGED_FONTS_REQUEST,
    payload,
});

export const saveChangedFontsSuccess: ActionCreator<SaveChangedFontsSuccessActionType> = payload => ({
    type: FormsActionTypes.SAVE_CHANGED_FONTS_SUCCESS,
    payload,
});

export const saveChangedFontsFailure: ActionCreator<SaveChangedFontsFailureActionType> = payload => ({
    type: FormsActionTypes.SAVE_CHANGED_FONTS_FAILURE,
    payload,
});

export const initFormButtons: ActionCreator<InitFormButtonsStylesActionType> = payload => ({
    type: FormsActionTypes.INIT_FORM_BUTTONS_STYLES,
    payload,
});

export const updateFormButtonsDataRequest: ActionCreator<UpdateFormButtonsDataRequest> = payload => ({
    type: FormsActionTypes.UPDATE_FORM_BUTTONS_DATA_REQUEST,
    payload,
});

export const transferFormAction: ActionCreator<TransferFormActionType> = payload => ({
    type: FormsActionTypes.TRANSFER_FORM,
    payload,
});

export const setTransferFormData: ActionCreator<SetTransferFormDataActionType> = payload => ({
    type: FormsActionTypes.SET_TRANSFER_FORM_DATA,
    payload,
});

export const transferFormSubmissions: ActionCreator<TransferFormSubmissionsActionType> = payload => ({
    type: FormsActionTypes.TRANSFER_FORM_SUBMISSIONS,
    payload,
});

export const setTransferIsLoading: ActionCreator<SetTransferFormLoadingActionType> = payload => ({
    type: FormsActionTypes.SET_TRANSFER_LOADING,
    payload,
});
